import { render, staticRenderFns } from "./ProductSkuSpecSections.vue?vue&type=template&id=3255cb40"
import script from "./ProductSkuSpecSections.vue?vue&type=script&lang=js"
export * from "./ProductSkuSpecSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports